import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row align-items-center py-4" }
const _hoisted_2 = { class: "col-lg-6 col-7" }
const _hoisted_3 = { class: "h2 text-white d-inline-block mb-0" }
const _hoisted_4 = {
  "aria-label": "breadcrumb",
  class: "d-none d-md-inline-block ml-md-4"
}
const _hoisted_5 = { class: "container-fluid mt--6" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-7" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Mis notificaciones")
], -1)
const _hoisted_10 = { class: "col-lg-6 col-5 text-right" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" No leídos ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Todas ")
const _hoisted_13 = { class: "text-muted font-weight-bold" }
const _hoisted_14 = { class: "mt-3 mb-0" }
const _hoisted_15 = { class: "text-sm mt-1 mb-0" }
const _hoisted_16 = { class: "mt-3" }
const _hoisted_17 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Rechazar ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Aceptar ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Aceptar ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "text-center text-sm" }, " No más notificaciones encontradas ", -1)

import TimeLine from "@/components/Timeline/TimeLine.vue";
import TimeLineItem from "@/components/Timeline/TimeLineItem.vue";
import RouteBreadcrumb from "@/components/Breadcrumb/RouteBreadcrumb.vue";
import BaseHeader from "@/components/BaseHeader.vue";
import { NotificationModule } from "@/store/modules/Notification";
import { computed } from "vue";
import { DateTime } from "ts-luxon";
import { AuthModule } from "@/store/modules/Auth";
import NotificationLoading from "../Loadings/NotificationLoading.vue";
import { useNotificationRef } from "@/plugins/notification";

// state

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
	notification: notyRef,
	cancel,
	loading,
	handleActions,
} = useNotificationRef();
//computed
const notifications = computed(() => NotificationModule.notifications);
const token = computed(() => AuthModule.token);
const all = computed(() => NotificationModule._all);

function getTimestamp(isodate: string) {
	return DateTime.fromISO(isodate)
		.setLocale("es")
		.toFormat("'El' dd 'de' LLLL 'a las' hh':'mm a");
}
function fetchNotifications(a: boolean) {
	NotificationModule.fetchNotifications({ token: token.value ?? "", all: a });
}

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_badge = _resolveComponent("badge")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BaseHeader, { class: "pb-6" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$route.name), 1),
            _createElementVNode("nav", _hoisted_4, [
              _createVNode(RouteBreadcrumb)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_card, { "header-classes": "bg-transparent" }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_base_button, {
                    size: "sm",
                    type: !_unref(all) ? 'primary' : 'neutral',
                    onClickCapture: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (fetchNotifications(false)), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }, 8, ["type"]),
                  _createVNode(_component_base_button, {
                    size: "sm",
                    type: _unref(all) ? 'primary' : 'neutral',
                    onClickCapture: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (fetchNotifications(true)), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["type"])
                ])
              ])
            ]),
            footer: _withCtx(() => [
              _hoisted_21
            ]),
            default: _withCtx(() => [
              (_unref(loading) && !_unref(notyRef))
                ? (_openBlock(), _createBlock(NotificationLoading, {
                    key: 0,
                    loading: _unref(loading) && !_unref(notyRef)
                  }, null, 8, ["loading"]))
                : (_openBlock(), _createBlock(TimeLine, {
                    key: 1,
                    type: "one-side"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications), (notification) => {
                        return (_openBlock(), _createBlock(TimeLineItem, {
                          key: notification._id,
                          "badge-type": notification.type ?? 'secondary',
                          "badge-icon": notification.icon ?? 'ni ni-bell-55'
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("small", _hoisted_13, _toDisplayString(getTimestamp(notification.createdAt)), 1),
                            _createElementVNode("h5", _hoisted_14, _toDisplayString(notification.title), 1),
                            _createElementVNode("p", _hoisted_15, _toDisplayString(notification.description), 1),
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_badge, {
                                rounded: "",
                                type: notification.answer?.split('/')[0]
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(notification.answer?.split("/")[1]), 1)
                                ]),
                                _: 2
                              }, 1032, ["type"])
                            ]),
                            (!notification.read)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  (notification.button)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(_component_base_button, {
                                          loading: 
												_unref(loading) && _unref(cancel) && _unref(notyRef) === notification._id
											,
                                          type: "warning",
                                          size: "sm",
                                          onClickCapture: _withModifiers(
												() => _unref(handleActions)(`read`, notification._id)
											, ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_18
                                          ]),
                                          _: 2
                                        }, 1032, ["loading", "onClickCapture"]),
                                        _createVNode(_component_base_button, {
                                          loading: 
												_unref(loading) && !_unref(cancel) && _unref(notyRef) === notification._id
											,
                                          type: "primary",
                                          size: "sm",
                                          onClickCapture: _withModifiers(
												() =>
													_unref(handleActions)(notification.action, notification._id)
											, ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_19
                                          ]),
                                          _: 2
                                        }, 1032, ["loading", "onClickCapture"])
                                      ], 64))
                                    : (_openBlock(), _createBlock(_component_base_button, {
                                        key: 1,
                                        loading: 
												_unref(loading) && _unref(cancel) && _unref(notyRef) === notification._id
											,
                                        type: "primary",
                                        size: "sm",
                                        onClickCapture: _withModifiers(
												() => _unref(handleActions)(`read`, notification._id)
											, ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_20
                                        ]),
                                        _: 2
                                      }, 1032, ["loading", "onClickCapture"]))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["badge-type", "badge-icon"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})